var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import * as paymentMethodFactory from '../../../classes/definitions/paymentMethod/paymentMethod';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import paymentMethodSchema from "../../../schemas/paymentMethodSchema";
import Input from '../../UI/Input/Input';
var PaymentMethodForm = /** @class */ (function (_super) {
    __extends(PaymentMethodForm, _super);
    function PaymentMethodForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.state = {
            formConfig: _.cloneDeep(paymentMethodSchema),
            formIsValid: false,
            discardPopupVisble: false
        };
        _this.getPaymentMethod = function (id) {
            _this.api.getPaymentMethod(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на метод на плащане';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var paymentMethod = paymentMethodFactory.createPaymentMethod(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'bg_name.value', paymentMethod.BgName);
            _.set(updatedFormConfig, 'bg_name.touched', true);
            _.set(updatedFormConfig, 'bg_name.valid', true);
            _.set(updatedFormConfig, 'en_name.value', paymentMethod.EnName);
            _.set(updatedFormConfig, 'en_name.touched', true);
            _.set(updatedFormConfig, 'en_name.valid', true);
            _.set(updatedFormConfig, 'active.value', paymentMethod.Active ? 'true' : 'false');
            _.set(updatedFormConfig, 'active.touched', true);
            _.set(updatedFormConfig, 'active.valid', true);
            _.set(updatedFormConfig, 'online_payment.value', paymentMethod.OnlinePayment ? 'true' : 'false');
            _.set(updatedFormConfig, 'online_payment.touched', true);
            _.set(updatedFormConfig, 'online_payment.valid', true);
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = id === 'active' || id === 'online_payment' ? event.target.value.toString() : event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedPaymentMethod = paymentMethodFactory.createPaymentMethod({
                active: _.get(formData, 'active.value', false),
                online_payment: _.get(formData, 'online_payment.value', false),
                bg_name: _.get(formData, 'bg_name.value', ''),
                en_name: _.get(formData, 'en_name.value', ''),
            });
            var actionMethod = _this.editId === '-1' ? _this.api.createPaymentMethod : _this.api.updatePaymentMethod;
            actionMethod(submittedPaymentMethod, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toPaymentMethodsPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на метод на плащане';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toPaymentMethodsPage = function () {
            _this.props.history.push(AppRoutes.paymentMethods.path);
        };
        return _this;
    }
    PaymentMethodForm.prototype.componentDidMount = function () {
        this.editId = _.get(this.props, 'match.params.id', '-1');
        if (this.editId !== '-1') {
            this.getPaymentMethod(this.editId);
        }
    };
    PaymentMethodForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key
                });
            }
        }
        // Building form inputs
        var form = (formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); } }));
        }));
        var actionBtns = React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toPaymentMethodsPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK"));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
            form,
            actionBtns));
    };
    return PaymentMethodForm;
}(React.Component));
// @ts-ignore
export default withRouter(PaymentMethodForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentMethods/PaymentMethodForm/PaymentMethodForm.tsx
// module id = 397
// module chunks = 0